export default __webpack_public_path__ + "static/marketing-solutions-11b0c6211dcb3d51722e96217500e663.png";